module.exports = __webpack_public_path__ + "img/icons B_40.be6c2d89.png";